<script>
export default {

  props: {
    traits: {},
    disabled: {},
    value: {}
  },

  data() {
    return {
      internalValue: this.value
    }
  },

  watch: {
    value() {
      this.internalValue = this.value
    },

    internalValue() {
      this.$emit('input', this.internalValue)
    }
  }

}
</script>

<template>
  <div class="columns">
    <div class="column">
      <div class="columns is-multiline">
        <div class="column is-4" v-for="(trait, uuid) in traits" :key="uuid">
          <b-checkbox :native-value="uuid" v-model="internalValue" :disabled="disabled">
            {{ trait.name }}
          </b-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

</style>